{
  "name": "Superfluid Token List C",
  "version": {
    "major": 3,
    "minor": 4,
    "patch": 0
  },
  "timestamp": "2024-01-31T09:52:41.437Z",
  "tokens": [
    {
      "address": "0xa60c5bebccdb9738f63891bbdd7fec3e762f9098",
      "name": "Super JoeToken",
      "symbol": "JOEx",
      "decimals": 18,
      "chainId": 43114,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/joe/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x6e84a6216ea6dacc71ee8e6b0a5b7322eebc0fdd",
      "name": "JoeToken",
      "symbol": "JOE",
      "decimals": 18,
      "chainId": 43114,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/joe/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xc0fbc4967259786c743361a5885ef49380473dcf",
      "name": "Aleph.im V2 SuperToken",
      "symbol": "ALEPH",
      "decimals": 18,
      "chainId": 43114,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/aleph/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x00d05eed85bad962ba5237dd4afff12004455a8a",
      "name": "Super fUSDC Fake Token",
      "symbol": "fUSDCx",
      "decimals": 18,
      "chainId": 43113,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x37a024d7f9ea1c7ebb658f5a14caeddd30f212b7"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x37a024d7f9ea1c7ebb658f5a14caeddd30f212b7",
      "name": "fUSDC Fake Token",
      "symbol": "fUSDC",
      "decimals": 18,
      "chainId": 43113,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x1290248e01ed2f9f863a9752a8aad396ef3a1b00",
      "name": "Super Aleph",
      "symbol": "ALEPH",
      "decimals": 18,
      "chainId": 43113,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/aleph/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x232a9cf3ded0f9f708099eb0cb8ed56313c02a4b",
      "name": "Super fTUSD Fake Token",
      "symbol": "fTUSDx",
      "decimals": 18,
      "chainId": 43113,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x2616c0ab36cac1e6df7f79ae7c3e297d579fe547"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x2616c0ab36cac1e6df7f79ae7c3e297d579fe547",
      "name": "fTUSD Fake Token",
      "symbol": "fTUSD",
      "decimals": 18,
      "chainId": 43113,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x24f3631dbbf6880c684c5e59578c21194e285baf",
      "name": "Super fDAI Fake Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 43113,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x3b526b50709a5551030673be284bc9c1e38351ac"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x3b526b50709a5551030673be284bc9c1e38351ac",
      "name": "fDAI Fake Token",
      "symbol": "fDAI",
      "decimals": 18,
      "chainId": 43113,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x34baf0a8292ec36b49f49eff07b374bdd7ba8703",
      "name": "Super Fake DAI Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 43113,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xffd0f6d73ee52c68bf1b01c8afa2529c97ca17f3",
      "name": "Super AVAX",
      "symbol": "AVAXx",
      "decimals": 18,
      "chainId": 43113,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/avax/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xfc55f2854e74b4f42d01a6d3daac4c52d9dfdcff",
      "name": "Super USD Coin",
      "symbol": "USDCx",
      "decimals": 18,
      "chainId": 42161,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xaf88d065e77c8cc2239327c5edb3a432268e5831"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xaf88d065e77c8cc2239327c5edb3a432268e5831",
      "name": "USD Coin",
      "symbol": "USDC",
      "decimals": 6,
      "chainId": 42161,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x675be78ed16cabe47f6d9f816d615c3d6d740508",
      "name": "Super fTUSD Fake Token",
      "symbol": "fTUSDx",
      "decimals": 18,
      "chainId": 421613,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x4e89088cd14064f38e5b2f309cfab9c864f9a8e6"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x4e89088cd14064f38e5b2f309cfab9c864f9a8e6",
      "name": "fTUSD Fake Token",
      "symbol": "fTUSD",
      "decimals": 18,
      "chainId": 421613,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xa4fd433d8c9956e842a78cac26700a07f33f53ff",
      "name": "Super fUSDC Fake Token",
      "symbol": "fUSDCx",
      "decimals": 18,
      "chainId": 421613,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xc67a95df1fc3cbeff3be969db36a73d5259b7654"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xc67a95df1fc3cbeff3be969db36a73d5259b7654",
      "name": "fUSDC Fake Token",
      "symbol": "fUSDC",
      "decimals": 18,
      "chainId": 421613,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xac7a5cf2e0a6db31456572871ee33eb6212014a9",
      "name": "Super fDAI Fake Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 421613,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xd0de1486f69495d49c02d8f541b7dadf9cf5cd91"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xd0de1486f69495d49c02d8f541b7dadf9cf5cd91",
      "name": "fDAI Fake Token",
      "symbol": "fDAI",
      "decimals": 18,
      "chainId": 421613,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xe01f8743677da897f4e7de9073b57bf034fc2433",
      "name": "Super ETH",
      "symbol": "ETHx",
      "decimals": 18,
      "chainId": 421613,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eth/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x46fd5cfb4c12d87acd3a13e92baa53240c661d93",
      "name": "Super ETH",
      "symbol": "ETHx",
      "decimals": 18,
      "chainId": 8453,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eth/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x4db26c973fae52f43bd96a8776c2bf1b0dc29556",
      "name": "Super USD Base Coin",
      "symbol": "USDbCx",
      "decimals": 18,
      "chainId": 8453,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca"
        }
      },
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xd9aaec86b65d86f6a7b5b1b0c42ffa531710b6ca",
      "name": "USD Base Coin",
      "symbol": "USDbC",
      "decimals": 6,
      "chainId": 8453,
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x708169c8c87563ce904e0a7f3bfc1f3b0b767f41",
      "name": "Super Dai Stablecoin",
      "symbol": "DAIx",
      "decimals": 18,
      "chainId": 8453,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x50c5725949a6f0c72e6c4a641f24049a917db0cb"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x50c5725949a6f0c72e6c4a641f24049a917db0cb",
      "name": "Dai Stablecoin",
      "symbol": "DAI",
      "decimals": 18,
      "chainId": 8453,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xd04383398dd2426297da660f9cca3d439af9ce1b",
      "name": "Super USDC",
      "symbol": "USDCx",
      "decimals": 18,
      "chainId": 8453,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x833589fcd6edb6e08f4c7c32d4f71b54bda02913",
      "name": "USD Coin",
      "symbol": "USDC",
      "decimals": 6,
      "chainId": 8453,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x15da1146dc9a7e10b3a9b256c9bebfa79fa8edc3",
      "name": "Super fUSDC Fake Token",
      "symbol": "fUSDCx",
      "decimals": 18,
      "chainId": 84531,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xf21019b8688e7730ca6d9002569ecbaf8d1a3083"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xf21019b8688e7730ca6d9002569ecbaf8d1a3083",
      "name": "fUSDC Fake Token",
      "symbol": "fUSDC",
      "decimals": 18,
      "chainId": 84531,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x3012dd229e227ba4b366fceac014440cdc900378",
      "name": "Super fTUSD Fake Token",
      "symbol": "fTUSDx",
      "decimals": 18,
      "chainId": 84531,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xadcf0ac9f2aa04a79fc64a1fdf0a0c9f3ae0556a"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xadcf0ac9f2aa04a79fc64a1fdf0a0c9f3ae0556a",
      "name": "fTUSD Fake Token",
      "symbol": "fTUSD",
      "decimals": 18,
      "chainId": 84531,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x4ec89df8b16474a9333bb94a5f21197ef89a8d87",
      "name": "Super fDAI Fake Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 84531,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x5735c32c38f5af0fb04a7c77c832ba4d7abffec8"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x5735c32c38f5af0fb04a7c77c832ba4d7abffec8",
      "name": "fDAI Fake Token",
      "symbol": "fDAI",
      "decimals": 18,
      "chainId": 84531,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x7ffce315b2014546ba461d54eded7aac70df4f53",
      "name": "Super ETH",
      "symbol": "ETHx",
      "decimals": 18,
      "chainId": 84531,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eth/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x06b6e03bc9711eeb58d5a381a476019e19fddec4",
      "name": "Super ECO CFA",
      "symbol": "eXOFx",
      "decimals": 18,
      "chainId": 42220,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x73f93dcc49cb8a239e2032663e9475dd5ef29a08"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/exof/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x73f93dcc49cb8a239e2032663e9475dd5ef29a08",
      "name": "ECO CFA",
      "symbol": "eXOF",
      "decimals": 18,
      "chainId": 42220,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/exof/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x0be89e17787c0ae021b5e4f84ae8444f900dd92c",
      "name": "Super TDL Fake Token",
      "symbol": "TDLx",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xea613e86842a6bbe2a7de22e1601af550bf3c372"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tdl/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xea613e86842a6bbe2a7de22e1601af550bf3c372",
      "name": "TDL Fake Token",
      "symbol": "TDL",
      "decimals": 18,
      "chainId": 5,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tdl/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x4632c3cf0da61db0e561deac37acf93a9ebfe789",
      "name": "Smile Super Token",
      "symbol": "SMILE",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/smile/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x5943f705abb6834cad767e6e4bb258bc48d9c947",
      "name": "Super ETH",
      "symbol": "ETHx",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eth/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x7d3e32ae08f50387a83cf222e08d8ec26317d7aa",
      "name": "Zaya Token",
      "symbol": "ZYA",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/zaya/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x8ae68021f6170e5a766be613cea0d75236ecca9a",
      "name": "Super fUSDC Fake Token",
      "symbol": "fUSDCx",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xc94dd466416a7dfe166ab2cf916d3875c049ebb7"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xc94dd466416a7dfe166ab2cf916d3875c049ebb7",
      "name": "fUSDC Fake Token",
      "symbol": "fUSDC",
      "decimals": 18,
      "chainId": 5,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x95697ec24439e3eb7ba588c7b279b9b369236941",
      "name": "Super fTUSD Fake Token",
      "symbol": "fTUSDx",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x53d00397f03147a9bd9c40443a105a82780deaf1"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x53d00397f03147a9bd9c40443a105a82780deaf1",
      "name": "fTUSD Fake Token",
      "symbol": "fTUSD",
      "decimals": 18,
      "chainId": 5,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xcc48a0349077b91ab540d2e46addffb4a4a26251",
      "name": "NTDL",
      "symbol": "NTDL",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/ntdl/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xdd610f0e0e29a33168d43e96399a638df86b9c43",
      "name": "Super FUND (Goerli)",
      "symbol": "FUNDx",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x30f29c05ae2e2243034ba28a1ac3bc3d807920bc"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fund/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x30f29c05ae2e2243034ba28a1ac3bc3d807920bc",
      "name": "FUND (Goerli)",
      "symbol": "FUND",
      "decimals": 9,
      "chainId": 5,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fund/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xf2d68898557ccb2cf4c10c3ef2b034b2a69dad00",
      "name": "Super fDAI Fake Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 5,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x88271d333c72e51516b67f5567c728e702b3eee8"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x88271d333c72e51516b67f5567c728e702b3eee8",
      "name": "fDAI Fake Token",
      "symbol": "fDAI",
      "decimals": 18,
      "chainId": 5,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x22064a21fee226d8ffb8818e7627d5ff6d0fc33a",
      "name": "Super Gho Token",
      "symbol": "GHOx",
      "decimals": 18,
      "chainId": 11155111,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xc4bf5cbdabe595361438f8c6a187bdc330539c60"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/gho/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xc4bf5cbdabe595361438f8c6a187bdc330539c60",
      "name": "Gho Token",
      "symbol": "GHO",
      "decimals": 18,
      "chainId": 11155111,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/gho/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x30a6933ca9230361972e413a15dc8114c952414e",
      "name": "Super ETH",
      "symbol": "ETHx",
      "decimals": 18,
      "chainId": 11155111,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eth/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x783fdeab6951504c4601184587aafed01511ed24",
      "name": "Super FUND (Sepolia)",
      "symbol": "FUNDx",
      "decimals": 18,
      "chainId": 11155111,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xafe70a1985ebdefbdcaeedba045d66091c38e1b1"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fund/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xafe70a1985ebdefbdcaeedba045d66091c38e1b1",
      "name": "FUND (Sepolia)",
      "symbol": "FUND",
      "decimals": 9,
      "chainId": 11155111,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fund/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x9ce2062b085a2268e8d769ffc040f6692315fd2c",
      "name": "Super fDAI Fake Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 11155111,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x4e89088cd14064f38e5b2f309cfab9c864f9a8e6"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x4e89088cd14064f38e5b2f309cfab9c864f9a8e6",
      "name": "fDAI Fake Token",
      "symbol": "fDAI",
      "decimals": 18,
      "chainId": 11155111,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xb598e6c621618a9f63788816ffb50ee2862d443b",
      "name": "Super fUSDC Fake Token",
      "symbol": "fUSDCx",
      "decimals": 18,
      "chainId": 11155111,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xe72f289584eda2be69cfe487f4638f09bac920db"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xe72f289584eda2be69cfe487f4638f09bac920db",
      "name": "fUSDC Fake Token",
      "symbol": "fUSDC",
      "decimals": 18,
      "chainId": 11155111,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x263647097a185ee0a9ded3e3e46d7eb931c23dda",
      "name": "Super Peerion",
      "symbol": "IONx",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xfa9454bbba1ddf83747bdc42bea8641475753c42"
        }
      },
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xfa9454bbba1ddf83747bdc42bea8641475753c42",
      "name": "Peerion",
      "symbol": "ION",
      "decimals": 18,
      "chainId": 100,
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x60fdb4d22e793353d98324d824034d66827f602e",
      "name": "NTDL",
      "symbol": "NTDL",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/ntdl/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x6689a8f4fdad6712888682c9ce81b26762389f40",
      "name": "Commons WORK",
      "symbol": "WORK",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x9c940356f5846eceff282d3ee8b33015d93502a9"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/work/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x9c940356f5846eceff282d3ee8b33015d93502a9",
      "name": "Commons protoWORK on xDai",
      "symbol": "protoWORK",
      "decimals": 18,
      "chainId": 100,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/work/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x66e454105ae553cfa87ad4dc4cdf128c841fcd73",
      "name": "TDLx",
      "symbol": "TDLx",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xcd1f2f1a1d1ba631a06b957db77bb9d7b13bf861"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tdl/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xcd1f2f1a1d1ba631a06b957db77bb9d7b13bf861",
      "name": "TDL Fake Token",
      "symbol": "TDL",
      "decimals": 18,
      "chainId": 100,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tdl/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x7aeca73f38f8f33ab7ff067fed1268384d12324d",
      "name": "Super Bright",
      "symbol": "Brightx",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x83ff60e2f93f8edd0637ef669c69d5fb4f64ca8e"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/bright/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x83ff60e2f93f8edd0637ef669c69d5fb4f64ca8e",
      "name": "Bright on xDai",
      "symbol": "BRIGHT",
      "decimals": 18,
      "chainId": 100,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/bright/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x7c78aa599bbaea6e8784880173eb74b2f9c46025",
      "name": "Super STREETBASED Community Token",
      "symbol": "SBCx",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x3b6a1b76d772a771bf3fce802bead6ff196b84d5"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/sbc/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x3b6a1b76d772a771bf3fce802bead6ff196b84d5",
      "name": "STREETBASED Community Token",
      "symbol": "SBC",
      "decimals": 18,
      "chainId": 100,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/sbc/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x83ccc929c1131d2d18b001c05cfeed9f3364a506",
      "name": "SuperSAVE",
      "symbol": "SAVEx",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x338d4527c9e7f7316c43581684bc510b851f832a"
        }
      },
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x338d4527c9e7f7316c43581684bc510b851f832a",
      "name": "Save Coin from Mainnet",
      "symbol": "SAVE",
      "decimals": 18,
      "chainId": 100,
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xa025df2bf4ff47ec458ab41e89d3a9538a768ea9",
      "name": "Super WORKtest",
      "symbol": "WORKtx",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xc8992645d060703fb1582c422c96e16941c7eb14"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/workt/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xc8992645d060703fb1582c422c96e16941c7eb14",
      "name": "Commons Work Test",
      "symbol": "WORKt",
      "decimals": 18,
      "chainId": 100,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/workt/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xa94c0e84b8f27deb34f50001d47d870b67e47466",
      "name": "superAC",
      "symbol": "ACx",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x5f1f81de1d21b97a5d0d5d62d89bde9ddec27325"
        }
      },
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x5f1f81de1d21b97a5d0d5d62d89bde9ddec27325",
      "name": "Adept Coin Governance on xDai",
      "symbol": "AC",
      "decimals": 18,
      "chainId": 100,
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xe83fd17028c2dd3ca4a9b75f2836d4558fe00686",
      "name": "HAUSx",
      "symbol": "HAUSx",
      "decimals": 18,
      "chainId": 100,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xb0c5f3100a4d9d9532a4cfd68c55f1ae8da987eb"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/haus/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xb0c5f3100a4d9d9532a4cfd68c55f1ae8da987eb",
      "name": "DAOhaus Token on xDai",
      "symbol": "HAUS",
      "decimals": 18,
      "chainId": 100,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/haus/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x3fa59ea0eee311782c5a5062da1fabd1a70e1d6d",
      "name": "Super REVV Token",
      "symbol": "REVVx",
      "decimals": 18,
      "chainId": 1,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x557b933a7c2c45672b610f8954a3deb39a51a8ca"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/revv/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x557b933a7c2c45672b610f8954a3deb39a51a8ca",
      "name": "REVV",
      "symbol": "REVV",
      "decimals": 18,
      "chainId": 1,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/revv/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x479347dfd0be56f2a5f7bb1506bfd7ab24d4ba26",
      "name": "Super Unification",
      "symbol": "FUNDx",
      "decimals": 18,
      "chainId": 1,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xe9b076b476d8865cdf79d1cf7df420ee397a7f75"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fund/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xe9b076b476d8865cdf79d1cf7df420ee397a7f75",
      "name": "Unification",
      "symbol": "FUND",
      "decimals": 9,
      "chainId": 1,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fund/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x4cab5b9930210e2edc6a905b9c75d615872a1a7e",
      "name": "Super Giveth Token",
      "symbol": "GIVx",
      "decimals": 18,
      "chainId": 10,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x528cdc92eab044e1e39fe43b9514bfdab4412b98"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/giv/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x528cdc92eab044e1e39fe43b9514bfdab4412b98",
      "name": "Giveth Token",
      "symbol": "GIV",
      "decimals": 18,
      "chainId": 10,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/giv/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xbd80cfa9d93a87d1bb895f810ea348e496611cd4",
      "name": "Own a fraction",
      "symbol": "FRACTION",
      "decimals": 18,
      "chainId": 10,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fraction/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xd782ac4ee247e0986522ca05c08cda330dfc14c4",
      "name": "Bogotix",
      "symbol": "BGX",
      "decimals": 18,
      "chainId": 10,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x675be78ed16cabe47f6d9f816d615c3d6d740508",
      "name": "Super fTUSD Fake Token",
      "symbol": "fTUSDx",
      "decimals": 18,
      "chainId": 69,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x4e89088cd14064f38e5b2f309cfab9c864f9a8e6"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x4e89088cd14064f38e5b2f309cfab9c864f9a8e6",
      "name": "fTUSD Fake Token",
      "symbol": "fTUSD",
      "decimals": 18,
      "chainId": 69,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xa4fd433d8c9956e842a78cac26700a07f33f53ff",
      "name": "Super fUSDC Fake Token",
      "symbol": "fUSDCx",
      "decimals": 18,
      "chainId": 69,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xc67a95df1fc3cbeff3be969db36a73d5259b7654"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xc67a95df1fc3cbeff3be969db36a73d5259b7654",
      "name": "fUSDC Fake Token",
      "symbol": "fUSDC",
      "decimals": 18,
      "chainId": 69,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xac7a5cf2e0a6db31456572871ee33eb6212014a9",
      "name": "Super fDAI Fake Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 69,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xd0de1486f69495d49c02d8f541b7dadf9cf5cd91"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xd0de1486f69495d49c02d8f541b7dadf9cf5cd91",
      "name": "fDAI Fake Token",
      "symbol": "fDAI",
      "decimals": 18,
      "chainId": 69,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xe01f8743677da897f4e7de9073b57bf034fc2433",
      "name": "Super ETH",
      "symbol": "ETHx",
      "decimals": 18,
      "chainId": 69,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eth/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x00f22a2b5c40ce03fa4c96ba97605e5a40cc97d4",
      "name": "CRE8R DAO",
      "symbol": "xCRE8R",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x079202ad852ccc46d8e73815f10ff055049d3916"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/xcre8r/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x079202ad852ccc46d8e73815f10ff055049d3916",
      "name": "CRE8R DAO (PoS)",
      "symbol": "CRE8R",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/xcre8r/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x07b24bbd834c1c546ece89ff95f71d9f13a2ebd1",
      "name": "Super USD Coin",
      "symbol": "USDCx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x3c499c542cef5e3811e1192ce70d8cc03d5c3359",
      "name": "USD Coin",
      "symbol": "USDC",
      "decimals": 6,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x0b524b829d243df5f70c81aa9f95e32851a57902",
      "name": "Super BetProtocolToken (PoS)",
      "symbol": "BEPROx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x07cc1cc3628cc1615120df781ef9fc8ec2feae09"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/bepro/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x07cc1cc3628cc1615120df781ef9fc8ec2feae09",
      "name": "BetProtocolToken (PoS)",
      "symbol": "BEPRO",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/bepro/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x1963e341ff5a75c41ca5ac400c828e636b70546e",
      "name": "DallorX",
      "symbol": "DUSx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x867d46fd484358a6f25655a705aa6ad804e6c6eb"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dus/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x867d46fd484358a6f25655a705aa6ad804e6c6eb",
      "name": "Dallor",
      "symbol": "DUS",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dus/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x19ca69c66768b487d28226c0a60ab2b2aa8e5c5c",
      "name": "REX Shirt 2023",
      "symbol": "rexSHIRT",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/rexshirt/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x2e12d38c6aa87cb68ce96c044b9a68dd98233ceb",
      "name": "Super Dbeats Token",
      "symbol": "DBEATx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x92e918ea7aa872f91bf7ec9bcd248a5920c9f3cb"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dbeat/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x92e918ea7aa872f91bf7ec9bcd248a5920c9f3cb",
      "name": "Dbeats Token",
      "symbol": "DBEAT",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dbeat/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x36d9a149895d905d117c38f3090f4344b76ec9f4",
      "name": "Super Xocolatl MXN Stablecoin",
      "symbol": "XOCx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xa411c9aa00e020e4f88bc19996d29c5b7adb4acf"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/xoc/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xa411c9aa00e020e4f88bc19996d29c5b7adb4acf",
      "name": "Xocolatl MXN Stablecoin",
      "symbol": "XOC",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/xoc/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x3862c15cdc4c38517aa4c6f94197a93253502168",
      "name": "Super Sunny Jaycer Token",
      "symbol": "SUNNYx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xd1d410db734d634414594898b39608b27f166aab"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/sunny/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xd1d410db734d634414594898b39608b27f166aab",
      "name": "Sunny Jaycer Token",
      "symbol": "SUNNY",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/sunny/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x3d9cc088bd9357e5941b68d26d6d09254a69949d",
      "name": "Super MTA",
      "symbol": "MTAx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xf501dd45a1198c2e1b5aef5314a68b9006d842e0"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/mta/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xf501dd45a1198c2e1b5aef5314a68b9006d842e0",
      "name": "Meta (PoS)",
      "symbol": "MTA",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/mta/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x5034f401716a6ceb26c8232fb5640075508085af",
      "name": "Super Waru Token V2",
      "symbol": "WARUx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xfa3872970c1952741c518b33f1dce815f55dc00a"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/waru/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xfa3872970c1952741c518b33f1dce815f55dc00a",
      "name": "Waru Token V2",
      "symbol": "WARU",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/waru/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x513412fcd5e0da4bed9102017164b84c06e557d4",
      "name": "Super Dood",
      "symbol": "Doodx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x8c36336211916c58860f1edf20b0f50ea66d8bd5"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dood/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x8c36336211916c58860f1edf20b0f50ea66d8bd5",
      "name": "Doodle 4081",
      "symbol": "Dood",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dood/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x520acbb446028dac642374773b312dbc577869fb",
      "name": "ClubX",
      "symbol": "ClubX",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/clubx/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x61a7b6f0a7737d9bd38fdeaf1d4160e16bf23043",
      "name": "SuperWork",
      "symbol": "WORKx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x6002410dda2fb88b4d0dc3c1d562f7761191ea80"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/work/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x6002410dda2fb88b4d0dc3c1d562f7761191ea80",
      "name": "The Employment Commons Work Token (PoS)",
      "symbol": "WORK",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/work/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x76220628fc2847c41b14967a75f3093f6e56998a",
      "name": "Super Dog Biscuits",
      "symbol": "BSCTx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x600e5f4920f90132725b43412d47a76bc2219f92"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/bsct/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x600e5f4920f90132725b43412d47a76bc2219f92",
      "name": "Dog Biscuits",
      "symbol": "BSCT",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/bsct/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xa6810e06fb8c93b2c53c0d6415c885719cba6eb5",
      "name": "Super KHIZA",
      "symbol": "KHIZAx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x25856d46748ee959f99a0fbbb5312c73473cb533"
        }
      },
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x25856d46748ee959f99a0fbbb5312c73473cb533",
      "name": "Khiza DAO",
      "symbol": "KHIZA",
      "decimals": 18,
      "chainId": 137,
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xa794221d92d77490ff319e95da1461bdf2bd3953",
      "name": "TDLx",
      "symbol": "TDLx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xcd1f2f1a1d1ba631a06b957db77bb9d7b13bf861"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tdl/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xcd1f2f1a1d1ba631a06b957db77bb9d7b13bf861",
      "name": "TDL Fake Token",
      "symbol": "TDL",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tdl/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xaff1ce7832a1c7655803533dab391920cafe467f",
      "name": "Super FLOAT",
      "symbol": "FLOATx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xf0ae1efde60bab0a830673747138f12367858e8d"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/float/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xf0ae1efde60bab0a830673747138f12367858e8d",
      "name": "Float Protocol: FLOAT (PoS)",
      "symbol": "FLOAT",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/float/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xb7d60973cc27324dcae837d89d7bd9c5f15e3833",
      "name": "Super Slatan ROTI Token",
      "symbol": "ROTIx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x13b4bd4c0719f9f46df35bfc234213b4df6e9b7c"
        }
      },
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x13b4bd4c0719f9f46df35bfc234213b4df6e9b7c",
      "name": "Slatan ROTI Token",
      "symbol": "ROTI",
      "decimals": 18,
      "chainId": 137,
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xc49c15350f001efee91e154f03bddf38cfd0d96e",
      "name": "Super Adept Camp Doge Coin",
      "symbol": "ACDCx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x1f02ec2dd0ff3e31ca893aec6c3585fe88243df3"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/acdc/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x1f02ec2dd0ff3e31ca893aec6c3585fe88243df3",
      "name": "Adept Camp Doge Coin",
      "symbol": "ACDC",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/acdc/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xd735b487b9018eeada2cc0464db02aa4b90ca711",
      "name": "NTDL",
      "symbol": "NTDL",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/ntdl/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xd89c35b586eadfbde1a3b2d36fb5746c6d3601bc",
      "name": "Super Metavault Trade Token",
      "symbol": "MVXx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x2760e46d9bb43dafcbecaad1f64b93207f9f0ed7"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/mvx/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x2760e46d9bb43dafcbecaad1f64b93207f9f0ed7",
      "name": "Metavault Trade",
      "symbol": "MVX",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/mvx/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xe0d1978033ee7cf12a8246da7f173f9441b769b0",
      "name": "Super REVV Token",
      "symbol": "REVVx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x70c006878a5a50ed185ac4c87d837633923de296"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/revv/icon.png",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x70c006878a5a50ed185ac4c87d837633923de296",
      "name": "REVV",
      "symbol": "REVV",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/revv/icon.png",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xe88f7c019dd3feb5e738681730fb150e62814670",
      "name": "Super CREEKS",
      "symbol": "CRKx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xf122a63f9fd807fa28a3495ad822ad84c934793d"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/crk/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xf122a63f9fd807fa28a3495ad822ad84c934793d",
      "name": "CREEKS",
      "symbol": "CRK",
      "decimals": 18,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/crk/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0xe91d640fcaea9602cf94c0d48a251a7f6d946953",
      "name": "REX Hat 2023",
      "symbol": "rexHAT",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/rexhat/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0xf1e073d53af781966f23b1a3b2d9e67cbba69b92",
      "name": "Super Unification (FXERC20)",
      "symbol": "fxFUNDx",
      "decimals": 18,
      "chainId": 137,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x1f0145eac900d75808510190dfc293a09c7a964f"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fund/icon.svg",
      "tags": [
        "supertoken",
        "tier_c"
      ]
    },
    {
      "address": "0x1f0145eac900d75808510190dfc293a09c7a964f",
      "name": "Unification (FXERC20)",
      "symbol": "fxFUND",
      "decimals": 9,
      "chainId": 137,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fund/icon.svg",
      "tags": [
        "underlying"
      ]
    },
    {
      "address": "0x0988dd6bfec3fd1b4accd4195987d3d759f99945",
      "name": "Super fTUSD Fake Token",
      "symbol": "fTUSDx",
      "decimals": 18,
      "chainId": 1101,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x992805ed822c786bcdba4cb1f07b5cada3bc3cba"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x992805ed822c786bcdba4cb1f07b5cada3bc3cba",
      "name": "fTUSD Fake Token",
      "symbol": "fTUSD",
      "decimals": 18,
      "chainId": 1101,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x33cb2412846068b57119c09bcb4454ee0b07e297",
      "name": "Super fUSDC Fake Token",
      "symbol": "fUSDCx",
      "decimals": 18,
      "chainId": 1101,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xf0d7d1d47109ba426b9d8a3cde1941327af1eea3"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xf0d7d1d47109ba426b9d8a3cde1941327af1eea3",
      "name": "fUSDC Fake Token",
      "symbol": "fUSDC",
      "decimals": 18,
      "chainId": 1101,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x6345aa6cec42a85160cf436810f97661e28c1876",
      "name": "Super ETH",
      "symbol": "ETHx",
      "decimals": 18,
      "chainId": 1101,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eth/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xf408daa31a958c4089f433eb239686c7809f8899",
      "name": "Super fDAI Fake Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 1101,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x94a8358e313044bc5bc4a615da4e59acaf3e1101"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x94a8358e313044bc5bc4a615da4e59acaf3e1101",
      "name": "fDAI Fake Token",
      "symbol": "fDAI",
      "decimals": 18,
      "chainId": 1101,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x42bb40bf79730451b11f6de1cba222f17b87afd7",
      "name": "Super fUSDC Fake Token",
      "symbol": "fUSDCx",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xbe49ac1eadac65dccf204d4df81d650b50122ab2"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xbe49ac1eadac65dccf204d4df81d650b50122ab2",
      "name": "fUSDC Fake Token",
      "symbol": "fUSDC",
      "decimals": 18,
      "chainId": 80001,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/usdc/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x5d8b4c2554aeb7e86f387b4d6c00ac33499ed01f",
      "name": "Super fDAI Fake Token",
      "symbol": "fDAIx",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0x15f0ca26781c3852f8166ed2ebce5d18265cceb7"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x15f0ca26781c3852f8166ed2ebce5d18265cceb7",
      "name": "fDAI Fake Token",
      "symbol": "fDAI",
      "decimals": 18,
      "chainId": 80001,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/dai/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x6c357412329f9a3ee07017be93ed0ac551faa77b",
      "name": "Army",
      "symbol": "ARMY",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x74950bcbb141ae70b8959fc06a65ac2601cf7801",
      "name": "NTDL",
      "symbol": "NTDL",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/ntdl/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x918e0d5c96cac79674e2d38066651212be3c9c48",
      "name": "Super fTUSD Fake Token",
      "symbol": "fTUSDx",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xa794c9ee519fd31bbce643e8d8138f735e97d1db"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xa794c9ee519fd31bbce643e8d8138f735e97d1db",
      "name": "fTUSD Fake Token",
      "symbol": "fTUSD",
      "decimals": 18,
      "chainId": 80001,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/tusd/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x96b82b65acf7072efeb00502f45757f254c2a0d4",
      "name": "Super MATIC",
      "symbol": "MATICx",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Native Asset"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/matic/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0x9acb4aff21c88ec743aade1f2a6c5fa623e675c2",
      "name": "Super Fichita",
      "symbol": "FICHx",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xe1f67d2683a3ea352047dc2c71c3ec6b1f7bd4bf"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fich/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xe1f67d2683a3ea352047dc2c71c3ec6b1f7bd4bf",
      "name": "Fichita",
      "symbol": "FICH",
      "decimals": 18,
      "chainId": 80001,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/fich/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0x9b5475182c65b88dbc5f452204d181e1ae919a1d",
      "name": "Super Monerium EUR emoney (EURe)",
      "symbol": "EURex",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Wrapper",
          "underlyingTokenAddress": "0xcf487efd00b70eac8c28c654356fb0e387e66d62"
        }
      },
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eure/icon.svg",
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    },
    {
      "address": "0xcf487efd00b70eac8c28c654356fb0e387e66d62",
      "name": "Monerium EUR emoney",
      "symbol": "EURe",
      "decimals": 18,
      "chainId": 80001,
      "logoURI": "https://raw.githubusercontent.com/superfluid-finance/assets/master/public/tokens/eure/icon.svg",
      "tags": [
        "underlying",
        "testnet"
      ]
    },
    {
      "address": "0xb891d8559feb358f4651745aaabfe97067b3bf81",
      "name": "Cash",
      "symbol": "CASH",
      "decimals": 18,
      "chainId": 80001,
      "extensions": {
        "superTokenInfo": {
          "type": "Pure"
        }
      },
      "tags": [
        "supertoken",
        "testnet",
        "tier_c"
      ]
    }
  ],
  "tags": {
    "supertoken": {
      "name": "SuperToken",
      "description": "This is a supertoken, learn more from the extensions."
    },
    "underlying": {
      "name": "Underlying Token",
      "description": "This is an underlying token, of a supertoken."
    },
    "testnet": {
      "name": "Testnet",
      "description": "This is a testnet token."
    },
    "tier_a": {
      "name": "Solvency Tier A",
      "description": "This is a Tier A token based on Solvency: Native Asset, or Stablecoin."
    },
    "tier_b": {
      "name": "Solvency Tier B",
      "description": "This is a Tier B token based on Solvency: Tied to a project or company, and has value, or utility."
    },
    "tier_c": {
      "name": "Solvency Tier C",
      "description": "This is a Tier C token based on Solvency: Not qualifying for Solvency Tier A or B."
    }
  }
}